/**
 * @file index.tsx
 *
 * @fileoverview Renders recommended applicants based on the job id.
 */

import ApplicantRecommenderLayout, {
  ApplicantRecommenderLayoutProps,
} from '~/jobiqo/components/ApplicantRecommender/components/Layout';
import { useQuery } from '@apollo/client';
import getMatchingApplicants from '~/jobiqo/components/ApplicantRecommender/graphql/queries/getMatchingApplicants';
import { FormattedMessage } from 'react-intl';

interface ApplicantRecommenderApplicants2JobProps
  extends Pick<ApplicantRecommenderLayoutProps, 'applicantsPerPage'> {
  /**
   * The job ID.
   */
  jobId: number;
}

export default function ApplicantRecommenderApplicants2Job({
  jobId,
}: ApplicantRecommenderApplicants2JobProps) {
  const { data, error, loading } = useQuery(getMatchingApplicants(), {
    variables: {
      context: 'APPLICANTS_2_JOB',
      entityId: jobId,
    },
  });

  return (
    <ApplicantRecommenderLayout
      loading={loading}
      error={Boolean(error || data?.getMatchingApplicants.errors.length > 0)}
      applicants={data?.getMatchingApplicants.items}
      Title={
        <FormattedMessage
          id="applicant_recommender_applicants_2_job_title"
          defaultMessage="Candidates matching this job"
        />
      }
      Description={
        <FormattedMessage
          id="applicant_recommender_applicants_2_job_description"
          defaultMessage="Looking for candidates? Based on the job you're viewing, here is a list of candidates that may be a good match for this position."
        />
      }
      showMatchingScore={true}
    />
  );
}

export { ApplicantRecommenderApplicants2Job };
